import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="-1 -1 16 24">
    <path
      fill="#A9B9C0"
      fillRule="evenodd"
      d="M10.175 21.332a.865.865 0 0 0 1.219 0l2.21-2.223a.849.849 0 0 0 0-1.205l-7.112-7.112 7.112-7.111a.849.849 0 0 0 0-1.206L11.394.252a.865.865 0 0 0-1.219 0L.251 10.189a.849.849 0 0 0 0 1.206l9.924 9.937z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/breadcrumbs-icon-back.es6.js